
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import CalculatorDisplay from './CalculatorDisplay';
import CalculatorKeypad from './CalculatorKeypad';
import { performCalculation } from './utils/calculatorUtils';

const SimpleCalculator = () => {
  const [display, setDisplay] = useState('0');
  const [firstOperand, setFirstOperand] = useState<number | null>(null);
  const [operator, setOperator] = useState<string | null>(null);
  const [waitingForSecondOperand, setWaitingForSecondOperand] = useState(false);

  const inputDigit = (digit: string) => {
    if (waitingForSecondOperand) {
      setDisplay(digit);
      setWaitingForSecondOperand(false);
    } else {
      setDisplay(display === '0' ? digit : display + digit);
    }
  };

  const inputDecimal = () => {
    if (waitingForSecondOperand) {
      setDisplay('0.');
      setWaitingForSecondOperand(false);
      return;
    }

    if (!display.includes('.')) {
      setDisplay(display + '.');
    }
  };

  const clear = () => {
    setDisplay('0');
    setFirstOperand(null);
    setOperator(null);
    setWaitingForSecondOperand(false);
  };

  const handleOperator = (nextOperator: string) => {
    const inputValue = parseFloat(display);

    if (firstOperand === null) {
      setFirstOperand(inputValue);
    } else if (operator) {
      const result = performCalculation(firstOperand, operator, inputValue);
      setDisplay(String(result));
      setFirstOperand(result);
    }

    setWaitingForSecondOperand(true);
    setOperator(nextOperator);
  };

  const handleEquals = () => {
    if (firstOperand === null || operator === null) {
      return;
    }

    const secondOperand = parseFloat(display);
    const result = performCalculation(firstOperand, operator, secondOperand);
    
    setDisplay(String(result));
    setFirstOperand(null);
    setOperator(null);
    setWaitingForSecondOperand(false);
  };

  return (
    <Card className="w-full max-w-sm mx-auto border-4 border-gray-700 rounded-lg shadow-lg bg-gray-800">
      <CardHeader className="p-3 border-b-4 border-gray-700 bg-gray-900">
        <CardTitle className="text-center text-green-500 font-mono">Calculator</CardTitle>
      </CardHeader>
      <CardContent className="p-3">
        <CalculatorDisplay value={display} />
        <CalculatorKeypad 
          onDigitClick={inputDigit}
          onOperatorClick={handleOperator}
          onDecimalClick={inputDecimal}
          onClearClick={clear}
          onEqualsClick={handleEquals}
        />
      </CardContent>
    </Card>
  );
};

export default SimpleCalculator;
